import { learnerPaths } from './route-paths'
import type { LearnerRouteId, LearnerScreenId } from './learner-route-types'

const temporarilyDisabledLearnerRouteIds = new Set<LearnerRouteId>([
  'short-videos',
])

const temporarilyDisabledLegacyScreens = new Set<number>([4])

export function isLearnerRouteEnabled(routeId: LearnerRouteId) {
  return !temporarilyDisabledLearnerRouteIds.has(routeId)
}

export function isLearnerLegacyScreenEnabled(screenId: LearnerScreenId | number) {
  return !temporarilyDisabledLegacyScreens.has(screenId)
}

export function getDisabledLearnerRouteFallbackPath(routeId: LearnerRouteId) {
  if (temporarilyDisabledLearnerRouteIds.has(routeId)) {
    return learnerPaths.learning
  }

  return null
}
